export const FETCH_CREATIVE_REQUEST = 'FETCH_CREATIVE_REQUEST';
export const FETCH_CREATIVE_DATA = 'FETCH_CREATIVE_DATA';
export const FETCH_CREATIVE_ERROR = 'FETCH_CREATIVE_ERROR';
export const RESET_CREATIVE_VIEW_DATA = 'RESET_CREATIVE_VIEW_DATA';
